(function() {
  'use strict';

  angular
    .module('factories.playerControls', [])
    .factory('PlayerControls', PlayerControls);

  PlayerControls.$inject = ['$timeout', 'MobileHelper'];

  function PlayerControls($timeout, MobileHelper) {
    var playerControls;
    var defaults = { fadeTime: MobileHelper.isTouch() ? 5000 : 2000 };

    function instantiateControls() {
      playerControls = {
        getHeaderControlsClass: getClass.bind(null, 'headerControlsVisible'),
        headerControlsVisible: false,
        getSlideControlsClass: getClass.bind(null, 'slideControlsVisible'),
        slideControlsVisible: false,

        timerDisabled: true,
        controlsFadePromise: null,
        resetControlsTimer: resetControlsTimer,
        stopControlsTimer: stopControlsTimer
      };
    }

    function getClass(controlVisible) {
      return playerControls[controlVisible] ? 'visible fadeIn' : 'mfhidden fadeOut';
    }

    function resetControlsTimer(options) {
      if (!MobileHelper.isTouch() || !MobileHelper.isMobileHeight())
        return;

      if (!options || !_.isObject(options))
        options = {};

      _.defaults(options, defaults);

      playerControls.timerDisabled = false;
      stopControlsTimer();

      playerControls.controlsFadePromise = $timeout(function() {
        playerControls.controlsFadePromise = null;
        playerControls.headerControlsVisible = false;
        playerControls.slideControlsVisible = false;
      }, options.fadeTime);
    }

    function stopControlsTimer() {
      if (playerControls.controlsFadePromise != null) {
        $timeout.cancel(playerControls.controlsFadePromise);
        playerControls.controlsFadePromise = null;
      }
    }

    if (!playerControls)
      instantiateControls();

    return playerControls;
  }
})();
